import { render, staticRenderFns } from "./FeaturedCourses.vue?vue&type=template&id=2f57f0c0&scoped=true"
import script from "./FeaturedCourses.vue?vue&type=script&lang=js"
export * from "./FeaturedCourses.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCourses.vue?vue&type=style&index=0&id=2f57f0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f57f0c0",
  null
  
)

export default component.exports